<script>
  export default {
    name: 'TheModal',
    props: {
      open: {
        type: Boolean,
        required: true,
        default: false
      },
      toggleModal: {
        type: Function,
        required: true,
        default: () => {}
      }
    },
    beforeMount () {
      if (this.open) document.querySelector('html').style.overflow = 'hidden'
    },
    beforeDestroy () {
      document.querySelector('html').style.overflow = 'auto'
    }
  }
</script>

<template>
  <dialog class="protected-bag-modal" :open="open" @click.self="toggleModal">
    <div class="protected-bag-modal__body">
      <button class="protected-bag-modal__close" @click="toggleModal">&times;</button>
      <div class="protected-bag-modal__content">
        <slot />
      </div>
    </div>
  </dialog>
</template>

<style lang="scss" scoped>
  .protected-bag-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(55 55 57 / 70%);
    border: none;
    z-index: 20;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;

    @media (max-width: 768px) {
      overflow-y: auto;
    }

    &__close {
      position: absolute;
      top: 0;
      right: 0;
      margin-top: 50px;
      margin-right: 33px;
      z-index: 30;
      font-family: sans-serif;
      font-size: 20px;
      line-height: 12px;
      height: 12px;
      width: 12px;
      text-align: center;

      @media (max-width: 768px) {
        opacity: 0;
        pointer-events: none;
      }
    }

    &__body {
      background: #FFFFFF;
      box-shadow: -4px 0px 20px rgba(0, 0, 0, 0.25);
      max-width: 416px;
      width: 100%;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;

      @media (max-width: 768px) {
        height: auto;
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        z-index: 2;
        top: 16px;
        right: calc(50% - 20px);
        width: 40px;
        height: 4px;
        background: #D5D5D7;
        border-radius: 12px;
        opacity: 0;
      }

      @media (max-width: 768px) {
        position: relative;
        margin-top: 40%;
        max-width: 100%;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
        overflow: hidden;

        &::after {
          opacity: 1;
        }
      }

      @media (max-width: 360px) {
        margin-top: 20%;
      }
    }

    &__content {
      height: 100%;
      overflow-y: auto;
      padding: 88px 0 0;

      @media (max-width: 768px) {
        overflow-y: initial;
        padding: 60px 0 0;
      }

      /* scrollbar */
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: #F5F5F5;
        box-shadow: inset 1px 1px 8px rgb(0 0 0 / 25%);
      }

      &::-webkit-scrollbar-thumb {
        background: #94989d;
      }
    }
  }
</style>
